import { useNavigate } from "react-router-dom";
import { AppModal } from "@/components/ui/AppModal";

export interface LoginModalTemplate {
  id: string;
  key: string;
  priorityBand: string;
  title: string;
  body: string;
  primaryCtaLabel: string;
  primaryCtaTarget: string;
  secondaryCtaLabel?: string | null;
  secondaryCtaTarget?: string | null;
  imageUrl?: string | null;
  dismissBehavior?: "ALLOWED" | "REQUIRED_ACTION";
}

interface LoginModalProps {
  isOpen: boolean;
  template: LoginModalTemplate;
  onDismiss: () => void;
  onImpression?: () => void;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
}

export function LoginModal({
  isOpen,
  template,
  onDismiss,
  onImpression,
  onPrimaryClick,
  onSecondaryClick,
}: LoginModalProps) {
  const navigate = useNavigate();
  const dismissBehavior = (template.dismissBehavior ?? "ALLOWED") === "ALLOWED" ? "DISMISS" : "REQUIRED_ACTION";

  const handlePrimary = () => {
    onPrimaryClick?.();
    onDismiss();
    navigate(template.primaryCtaTarget);
  };

  const handleSecondary = () => {
    onSecondaryClick?.();
    onDismiss();
    if (template.secondaryCtaTarget) {
      navigate(template.secondaryCtaTarget);
    }
  };

  return (
    <AppModal
      kind="login_first_run"
      isOpen={isOpen}
      title={template.title}
      body={template.body}
      imageUrl={template.imageUrl ?? undefined}
      primaryLabel={template.primaryCtaLabel}
      onPrimary={handlePrimary}
      secondaryLabel={template.secondaryCtaLabel ?? undefined}
      onSecondary={template.secondaryCtaLabel ? handleSecondary : undefined}
      onClose={onDismiss}
      dismissBehavior={dismissBehavior}
    />
  );
}
